import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import AuthPage from "components/AuthPage";
import LoadingSpinner from "components/LoadingSpinner";
import { useSignOutUser } from "hooks";
import api from "utils/api";

const useStyles = makeStyles((theme) => ({
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
}));

const AuthPopupPage = (props) => {
  const classes = useStyles();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get("mode");
  const isLogin = mode === "login";
  const [loading, setLoading] = useState(false);
  const [clearingInitialUserState, setClearingInitialUserState] = useState(true);

  const authUser = useSelector((state) => state.user.authUser);
  const fbToken = useSelector((state) => state.user.firebaseToken);
  const signOutUser = useSignOutUser();

  const isLoading = loading || clearingInitialUserState;

  const checkTokenIsValid = async (token) => {
    const response = await api.verifyFirebaseToken(token);
    return response.status === 200;
  };
  const handleClearingInitialUser = async () => {
    setClearingInitialUserState(true);
    try {
      await signOutUser();
      setClearingInitialUserState(false);
    } catch (error) {
      setClearingInitialUserState(false);
      console.error("Error signing out user:", error);
    }
  };

  useEffect(() => {
    // Clear any previous authentication state
    if (authUser && fbToken) {
      handleClearingInitialUser();
    } else {
      setClearingInitialUserState(false);
    }
  }, []);

  useEffect(() => {
    const handleAuthentication = async () => {
      if (authUser && fbToken && window.opener) {
        try {
          setLoading(true);
          const isCurrentTokenValid = await checkTokenIsValid(fbToken);

          if (isCurrentTokenValid) {
            window.opener.postMessage(
              {
                type: "AUTH_COMPLETE",
                success: true,
                authUser: authUser,
                fbToken: fbToken,
              },
              process.env.REACT_APP_MOLLIES_IFRAME_HOST
            );

            await signOutUser();
            setLoading(false);

            window.close();
          } else {
            signOutUser();
            setLoading(false);
          }
        } catch (error) {
          setLoading(false);
          console.error("Error verifying token:", error);
        }
      }
    };
    if (!clearingInitialUserState) {
      handleAuthentication();
    }
  }, [authUser, fbToken, clearingInitialUserState]);

  const handleAuthCompleted = () => {
    // This will be handled by the useEffect above when authUser changes
    // No need to duplicate the logic here
  };

  return (
    <>
      {isLoading && (
        <div className={classes.loadingOverlay}>
          <LoadingSpinner loading={isLoading} />
        </div>
      )}
      <AuthPage
        login={isLogin}
        signUp={!isLogin}
        isAuthPopup
        onNotifOpen={props.onNotifOpen}
        authCompleted={handleAuthCompleted}
      />
    </>
  );
};

AuthPopupPage.propTypes = {
  onNotifOpen: PropTypes.func,
};

export default AuthPopupPage;
